import React from 'react';
import { IFlexibleSetsWrapperProps } from '../searchresultpage.d';
import { PageViewLogDataId, SearchTelemetryAjaxCaller, SearchTelemetryData } from '../SearchTelemetryAjaxCaller';
import * as helper from '../../../Common/html-helper';
import * as setHelper from './flexible-set-mapper';
import ArrowDownIcn from '../../../Assets/svg/arrow_down';
import classNames from 'classnames';
import FspTileGrid from '../../flexSets/fspTileGrid/fsp-tile-grid';
import styles from './flexible-set-list-wrapper.scss';

const FlexibleSetListWrapper = (props: IFlexibleSetsWrapperProps) => {
    const tabNavAttribute = { focusable: true };
    const gridRef = React.createRef<HTMLDivElement>();
    const placeholderCategory = setHelper.getPlaceholderCategory();
    const flexibleSetTilePrices = props.flexibleSetContext.flexibleSets.map((set) => set.price);
    const flexibleSetTileGridData = setHelper.mapToFlexibleSetTiles(props.flexibleSetContext.flexibleSets);
    const buttonInfo = props.flexibleSetContext.flexSetButton;
    const buttonText = helper.decodeHTML(props.l10n.viewAllResults);
    const isTeaserPage = props.searchPageStyle === 'multiple-alternative-search-results';
    const dataStm = isTeaserPage ? { 'data-stm': buttonInfo.telemetryData.stm } : {};
    const setHeadlineText =
        props.l10n.startQuotationMark +
        props.searchTerm +
        props.l10n.endQuotationMark +
        ' ' +
        helper.decodeHTML(props.l10n.searchTermInSets) +
        ':';

    const handleTelemetry = () => {
        if (!isTeaserPage) return;
        const data = new SearchTelemetryData(
            buttonInfo.telemetryData.stm,
            PageViewLogDataId.getInstance().get(),
            props.portal,
            props.culture,
            props.magicLink
        );
        SearchTelemetryAjaxCaller.postData(data);
    };

    const handleTabNavigation = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (event.key === ' ') {
            event.preventDefault(); // prevent page jump
            event.currentTarget?.click();
        }
    };

    return (
        <div className={classNames(styles.flexible_set_list_wrapper, `fas_${props.searchPageStyle}`)}>
            <div className={styles.flex_sets_divider}>
                <span className={styles.headline} 
                    dangerouslySetInnerHTML={{ __html: setHeadlineText }}>
                </span>
            </div>

            <FspTileGrid
                currencyInformation={props.flexibleSetContext.setCurrencyInformation}
                flexSets={flexibleSetTileGridData}
                setPrice={flexibleSetTilePrices}
                category={placeholderCategory}
                l10n={props.l10n}
                kiosk={props.kiosk}
                isMobile={props.isMobile}
                isGlobal={props.isGlobal}
                gridRef={gridRef}
                addItemOriginToPdpLink={true}
                portal={props.portal}
                culture={props.culture}
            />

            <div className={styles.sets_button_container}>
                <div className={styles.sets_button_wrapper}>
                    <a
                        className={styles.sets_button}
                        href={buttonInfo.flexSetBaseCategoryLink}
                        {...dataStm}
                        onClick={() => handleTelemetry()}
                        {...tabNavAttribute}
                        onKeyDown={(e) => handleTabNavigation(e)}
                        aria-label={`${props.searchTerm}, ${buttonText}`}
                    >
                        <span>{buttonText}</span>
                        <ArrowDownIcn />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default FlexibleSetListWrapper;
